// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewManagedTooltip_wrapper__3msXZ","flex":"NewManagedTooltip_flex__3dqq0","box":"NewManagedTooltip_box__3Ysat","intentSuccess":"NewManagedTooltip_intentSuccess__3ghKW"};